<label class="mnf-control">
   <p class="mnf-control-label">{{ label }} <i *ngIf="info" class="my-auto ms-2 mnf-question" mat-raised-button
         [matTooltip]="info" [matTooltipPosition]="'right'" [attr.aria-label]="label"></i>
   </p>
   <input class="mnf-input-form" [ngClass]="{ error: control.touched && !control.valid, flat: _flat }" [type]="type"
      [formControl]="control" [placeholder]="placeholder" [mask]="mask" [attr.id]="id"
      [specialCharacters]="specialCharacters" [dropSpecialCharacters]="dropSpecialCharacters"
      [patterns]="customPatterns" (ngModelChange)="changeModel($event)">
   <span class="msg-error" *ngIf="errMsg">{{ control.touched && control.invalid ? errMsg : ""}}</span>
</label>
